<template>
  <div>
    <!-- TODO refactor this to show the last action state. e.g. if blocked is set after the user opt outed then show the blocked view first. -->
    <UserOptOuted
      v-if="activeConversation && activeConversation.contact && !activeConversation.contact.has_messaging_consent" />
    <ContactBlocked
      v-else-if="activeConversation && contactIsBlocked"
      :conversation="activeConversation"
      @click="openSendNotificationModal" />
    <MoreThan24Hours
      v-else-if="moreThan24HoursPassed"
      @click="openSendNotificationModal" />
    <MessageInput
      v-else
      ref="messageInputRef"
      class="footer-input"
      :focus-shadow="true"
      :reply-to="messageToReply[activeConversation.id] ? messageToReply[activeConversation.id] : null"
      @notification-btn-pressed="openSendNotificationModal" />

    <NotificationModal
      v-if="activeConversation"
      ref="notificationSendModal"
      :class="{ hide: createNewModalVisible }"
      @create-new-template="createNewTemplate" />

    <MessageTemplateModal
      ref="messageTemplateModalRef"
      :static-modal="true"
      :business-id="$route.params.businessId"
      @hidden="createNewModalVisible = false"
      @abort="closeModals" />

    <TemplateMissingModal />
    <NewConversationNotificationModal @start-new-notification="startNewNotification"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import NotificationModal from '../notifications/modals/NotificationModal';
import MessageInput from './partials/MessageInput';
import MoreThan24Hours from './partials/MoreThan24Hours';
import UserOptOuted from './partials/UserOptOuted';
import ContactBlocked from './partials/ContactBlocked';
import SBColors from '@/helpers/lists/colors';
import TemplateMissingModal from '../notifications/modals/TemplateMissing.modal';
import NewConversationNotificationModal from '../notifications/modals/NewConversationNotification.modal';
import MessageTemplateModal from '@/components/business/settings/modals/MessageTemplate.modal';
import ToasterMixin from '@/mixins/Toaster';

export default {
  name: 'MessagesFooter',
  components: {
    MessageInput,
    MoreThan24Hours,
    NotificationModal,
    UserOptOuted,
    MessageTemplateModal,
    ContactBlocked,
    TemplateMissingModal,
    NewConversationNotificationModal,
  },
  mixins: [
    ToasterMixin,
  ],
  data() {
    return {
      moreThan24HoursPassed: true,
      createNewModalVisible: false,
      reset24HourTimeout: null,
      messageToReply: {},
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      activeConversation: 'chat/activeConversation',
      contact: 'contact/contact',
      contactData: 'contactDetails/contactData',
      templateMessageList: 'notification/templateMessageList',
      userPermissions: 'user/userPermissions',
      currentOrganisation: 'organisation/currentOrganisation',
      messagesLoading: 'chat/messagesLoading',
      newMessageConversation: 'pusher/newMessageConversation',
      inputMessageText: 'chat/inputMessageText',
    }),
    contactIsBlocked() {
      return this.activeConversation && this.activeConversation.blocked;
    },
  },
  watch: {
    activeConversation() {
      this.set24HourButtonVisibility();
      // this.hasSendNotificationPermission = this.$hasPermission('send_notifications', businessId); // TODO refactor all the permissions like this to new model

      this.$nextTick(() => {
        if (this.activeConversation && this.activeConversation.openSendNotification) {
          this.openSendNotificationModal();
        }
      });
    },
    newMessageConversation() {
      this.$nextTick(() => {
        this.set24HourButtonVisibility();
      });
    },
  },
  mounted() {
    this.$eventBus.$on('media-modal-opened', this.clearInputText);
    this.$eventBus.$on('media-modal-closed', this.resetInputHtml);
    this.$eventBus.$on('start-reply', this.setReplyMessage);
    this.$eventBus.$on('cancel-reply-to', () => { this.messageToReply[this.activeConversation.id] = null; });
    this.$eventBus.$on('addoutboundmessage', () => { this.messageToReply[this.activeConversation.id] = null; });

    this.set24HourButtonVisibility();

    this.$nextTick(() => {
      if (this.activeConversation && this.activeConversation.openSendNotification) {
        this.openSendNotificationModal();
      }
    });
  },
  methods: {
    ...mapActions({
      updateInputMessage: 'chat/updateInputMessage',
    }),
    setReplyMessage(message) {
      this.messageToReply[this.activeConversation.id] = message;
      this.messageToReply = { ...this.messageToReply };
    },
    clearInputText() {
      this.$nextTick(() => {
        if (this.$refs.messageInputRef && this.$refs.messageInputRef.messageContent) {
          const messageContentBkp = this.$refs.messageInputRef.messageContent.toString();
          this.$refs.messageInputRef.resetTextTo('');
          if (!this.$refs.messageInputRef.preventStoreChanges) {
            this.$nextTick(() => {
              this.updateInputMessage(messageContentBkp);
            });
          }
        }
      });
    },
    resetInputHtml() {
      if (this.$refs.messageInputRef) {
        this.$refs.messageInputRef.setHtml(this.inputMessageText ? this.inputMessageText : '');
      }
    },
    closeModals() {
      this.$refs.notificationSendModal.hide();
    },
    createNewTemplate() {
      const config = {
        backAction: () => {
          this.$refs.messageTemplateModalRef.hide();
        },
        noFade: true,
        forceNew: true,
      };
      this.createNewModalVisible = true;
      this.$refs.messageTemplateModalRef.show(config);
    },
    openSendNotificationModal() {
      if (this.userPermissions[this.currentOrganisation.id].includes('send_notifications')) {
        if (this.activeConversation && this.activeConversation.id && this.activeConversation.id.startsWith('TEMP')) {
          const name = this.activeConversation.name ? this.activeConversation.name : this.activeConversation.phone;
          if (this.hasApprovedTemplateMessages()) {
            // Uncomment this to get consent modal first
            // const name = this.activeConversation.name ? this.activeConversation.name : this.activeConversation.phone;
            // this.$eventBus.$emit('show-notification-modal', {
            //   phone: name,
            //   businessId: this.activeConversation.businessId,
            //   templateMessageList: { ...this.templateMessageList },
            // });
            this.$refs.notificationSendModal.show();
          } else {
            this.$eventBus.$emit('show-template-missing-modal', name);
          }
        } else if (this.activeConversation && this.activeConversation.id) {
          this.$refs.notificationSendModal.show();
        }
      } else {
        // this.$infoModal.show({
        //   message: 'You don\'t have a permission to do this action.',
        // });

        this.showToaster('You don’t have a permission to do this action.', null, null, 'warning');
      }
    },
    /**
     * Sets the notification button visibility.
     */
    set24HourButtonVisibility() {
      if (this.activeConversation) {
        const lastInboundDate = this.activeConversation.inbound_sent_at;
        this.moreThan24HoursPassed = Boolean(!lastInboundDate || this.$moment().diff(this.$moment(false, false).unix(lastInboundDate), 'days') > 0);

        if (!this.moreThan24HoursPassed) {
          this.$eventBus.$emit('scroll-to-bottom-messages');
          this.$eventBus.$emit('24-hour-window-closed', false);
        } else {
          this.$eventBus.$emit('24-hour-window-closed', true);
        }

        if (lastInboundDate) {
          const secondsLeft = this.$moment(false, false).unix(lastInboundDate).add(1, 'days').unix() - this.$moment().unix();
          if (secondsLeft > 0) {
            this.reset24HourTimeout = setTimeout(() => {
              this.set24HourButtonVisibility();
            }, secondsLeft * 1000); // +5 seconds just in case because if set tightly then the 1 day compare time could have a second or two less.
          }
        }
      }
    },
    /** Checks if there is at least one approved template message. */
    hasApprovedTemplateMessages() {
      let hasApprovedTemplates = false;
      if (this.templateMessageList.data.some(templateLang => templateLang.status === 'approved')) {
        hasApprovedTemplates = true;
      }
      return hasApprovedTemplates;
    },
    startNewNotification() {
      this.$refs.notificationSendModal.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.footer-input {
  margin: 0 15px 15px 15px;
}

::v-deep {
  .emoji-picker {
    left: unset !important;
    top: unset !important;
  }
}
</style>
